import { render } from "./DocCompDocUpload.vue?vue&type=template&id=1d295133&scoped=true"
import script from "./DocCompDocUpload.vue?vue&type=script&lang=js"
export * from "./DocCompDocUpload.vue?vue&type=script&lang=js"

import "./DocCompDocUpload.vue?vue&type=style&index=0&id=1d295133&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d295133"]])

export default __exports__